import React from 'react';
import { IconSvgProps } from '@models/common';

const Clock: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M10 5v5l3.333 1.667M1.667 10c0 4.6 3.734 8.333 8.333 8.333 4.6 0 8.333-3.734 8.333-8.333 0-4.6-3.734-8.333-8.333-8.333A8.337 8.337 0 0 0 1.667 10v0'
        stroke='currentColor'
        strokeWidth='1.667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Clock;
